Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    linkForegroundColorDefault: tokens.themeActionPrimaryDefault,
    linkForegroundColorHover: tokens.themeActionPrimaryHover,
    linkForegroundColorPressed: tokens.themeActionPrimaryPressed,
    linkForegroundColorDisabled: tokens.themeActionPrimaryDisabled,
    linkMotionDuration: "100ms",
    linkMotionFunction: "ease"
  }
};